$(function () {
    // Set offset for anchor so it doesn't scroll too far.
    // Smooth scroll anchor
    $('a[href*="#"]:not([href="#"])').click(function () {
      var offset = -115; // <-- change the value here
      if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top + offset,
          }, 500);
          return false;
        }
      }
    });
  });
  



// WEBPACK FOOTER //
// ./scripts/routes/anchor-scroll-offset.js